<template>
    <div class="footer-box">
        <div class="footer-text">
          <span @click="toTermsOfService">利用規約</span>
          <span @click="toPrivacyPolicy">プライバシーポリシー</span>
          <span @click="toFeedback">問い合わせ</span>
        </div>
        <!-- <div class="footer-text">{{copyright}}</div> -->
    </div>
</template>
<script>
  export default {
    // data () {
    //   return {
    //     text: 'プライバシーポリシー',
    //     copyright: '＠All rights deserved'
    //   }
    // },
    components: {},
    methods:{
      toFeedback(){
        this.$router.push('/feedback/feedback')
        // window.open('#/feedback/feedback', '_blank')
      },
      toTermsOfService(){
        window.open('#/terms-of-service', '_blank')
      },
      toPrivacyPolicy(){
        window.open('#/privacy-policy', '_blank')
      }
    }
  }
</script>
<style scoped>
    span{
      cursor: pointer;
    }
    .footer-box {
        width: 100%;
        height: 80px;
        /* position: fixed;
        bottom: 0; */
        margin-top: 5rem;
        /* font-family: 'Roboto'; */
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 30px;
        color: #FFF;
        text-align: center;
        display: block;
    }
    @media (max-width: 1024px) {
        .footer-box {
            position: inherit !important;
        }
    }
    @media (max-width: 460px) {
        .footer-box {
            position: inherit !important;
        }
    }
</style>



// WEBPACK FOOTER //
// footer.vue?6f09931e